import API from "@/global/request/api";
import axios from "@/global/request/axios";

export default {
  list(params) {
    return axios.get(API.gift, params);
  },
  addressList(params) {
    return axios.get(API.address, params);
  },
  addressCreate(params) {
    return axios.post(API.address, params);
  },
  addressEdit(id, params) {
    return axios.put(API.addressId(id), params);
  },
  addressDetail(id) {
    return axios.get(API.addressId(id));
  },
  addressDefault() {
    return axios.get(API.addressDefault);
  },
  myGiftList(params) {
    return axios.get(API.myGift, params);
  },
  giftExchange(id, params) {
    return axios.post(API.giftOrder(id), params);
  },
  addressDelete(id) {
    return axios.delete(API.addressId(id));
  }
};
